/**
 * datetimepicker
 * Automatically resolve all datetime pickers with default settings
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

require ('@foxythemes/bootstrap-datetime-picker-bs4');

$(function() {

    "use strict";

    // And config
    $(".datetimepicker").datetimepicker({
        autoclose: true,
        componentIcon: '.mdi.mdi-calendar',
        navIcons:{
            rightIcon: 'mdi mdi-chevron-right',
            leftIcon: 'mdi mdi-chevron-left'
        }
    });
});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/datetimepicker.js